import * as React from 'react';
import { Text, TextArea, Image } from '../components/forms';
import Page from '../components/Page';
import Section from '../components/Section';
import Box from '../components/Box';
import { ButtonStyle } from '../components/Button';
import { ActionBar, ActionBarStyle } from '../components/ActionBar';
import { Category } from '../product';
import { ErrorFlash, SuccessFlash } from '../components/Flash';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequestAsync, getHeaders } from '../api/client';
import { CategorySelect } from '../components/forms/CategorySelect';

type Props = {
  category: Category;
};

const update = (context: ProfileManager) =>
  useRequestAsync((data: Category) => ({
    url: data.id ? `/store/categories/${data.id}` : '/store/categories/new',
    method: data.id ? 'PUT' : 'POST',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));

const setValue = (obj: Category, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

export default function EditCategory(props: Props) {
  const context = React.useContext(ProfileContext);
  const [category, setCategory] = React.useState(props.category);

  const [state, submit] = update(context);

  const handleFormSubmit = () =>
    submit({
      ...props.category,
      ...category,
    });

  return (
    <Page title={category.name || 'A new category'} subtitle="Edit category">
      {state.error && <ErrorFlash error={state.error} />}
      {state.complete && state.data && (
        <SuccessFlash text="Category has been saved" />
      )}
      <form onSubmit={handleFormSubmit} id="category">
        <Section title="Basic details">
          <div className="flex">
            <div className="flex-auto w-50 pr2">
              <Text
                label="Name"
                field={['name']}
                id="name"
                defaultValue={category.name}
                onValueChange={setValue(category, setCategory)}
              />
              <TextArea
                label="Description"
                field={['description_text']}
                id="description_text"
                defaultValue={category.description_text}
                onValueChange={setValue(category, setCategory)}
              />
              <CategorySelect
                label="Parent"
                field={['parent_id']}
                id="parent_id"
                defaultValue={category.parent_id}
                onValueChange={setValue(category, setCategory)}
              />
            </div>
            <div className="flex-auto pa3 ph5 tc w-50">
              <img
                src={category.image_url || '/images/methods/add.png'}
                className="br-100 h5 w5 dib mb3"
                alt="Avatar"
              />
              <Image
                label="Image"
                field={['image_url']}
                id="image_url"
                defaultValue={category.image_url}
                onValueChange={setValue(category, setCategory)}
              />
            </div>
          </div>
        </Section>
        <ActionBar
          className={ActionBarStyle.alignCenter}
          actions={[
            {
              className: ButtonStyle.Confirm,
              label: 'Save',
              handler: handleFormSubmit,
            },
          ]}
        />
      </form>
    </Page>
  );
}
